import z from "zod";

export const uploadFileReq = z.object({
  filename: z.string().min(1),
  contentType: z.string().min(1),
});
export type UploadFileReq = z.infer<typeof uploadFileReq>;

const uploadFileResp = z.object({
  fileId: z.string(),
  signedUrl: z.string(),
  expiresIn: z.number(),
  filename: z.string(),
  // Canonical content type the signed URL was generated for. The client must
  // PUT with this value so the GCS v4 signature matches (see fileUpload.ts).
  contentType: z.string(),
});
export type UploadFileResp = z.infer<typeof uploadFileResp>;

/**
 * Whether an image can be previewed inline. HEIC and HEIF are refused: browsers
 * and React Native cannot display them, and decoding them per request is heavy
 * enough to exhaust memory under concurrency. iPhone photos default to HEIC, so
 * those show as a file chip instead.
 */
export function isPreviewableImageType(mimeType: string): boolean {
  return mimeType.startsWith("image/") && mimeType !== "image/heic" && mimeType !== "image/heif";
}
